import CloudinaryReportElementGeneral from "./cloudinary-report-general-elmt";


const CloudinaryReportElements = {
    General : CloudinaryReportElementGeneral,
}

export default CloudinaryReportElements;